<div class="myPurchase-dialog-container">
    <div class="myPurchase-dialog-header">
        Update Attachment
    </div>
    <div class="myPurchase-dialog-content">
        <div class="field-row mb-2 paragraph-medium-regular">
            <p *ngIf="data.type === AttachmentTaggingType.DOCUMENT_TO_VENDOR">
                Select the items you wish to tag the attachment to.
            </p>
            <p *ngIf="data.type === AttachmentTaggingType.QUOTATION">
                Select the vendor you wish to tag the attachment to.
            </p>
        </div>
        <div class="field-row paragraph-medium-regular">
            <p class="field-label">File Name:</p>
            <p>{{data.filename}}</p>
        </div>
        <div>
            <div class="field-row paragraph-medium-regular">
                <p class="field-label">Purpose:</p>
                <p>{{data.selectedPurpose}}</p>
            </div>
        </div>

        <div *ngIf="data.type === AttachmentTaggingType.DOCUMENT_TO_VENDOR" class="mt-3">
            <app-select-item-table (onSelectedChange)="onItemNumberSelectedChange($event)"
                [selectedItemNumbers]="formData.selectedItemNumbers"
                [itemDisplayColumns]="['select', 'displayItemNumber', 'itemDescription', 'partModelNumber', 'quantity', 'brand', 'criticality', 'purchaseExecutiveName']"></app-select-item-table>
        </div>

        <ng-container *ngIf="data.type === AttachmentTaggingType.QUOTATION">
            <ng-container *ngIf="rfqNumberDropdownOptions && rfqNumberDropdownOptions.length > 0">
                <div>
                    <p class="mb-0 mt-2 paragraph-medium-regular">RFQ No.</p>
                    <ng-select [items]="rfqNumberDropdownOptions" [(ngModel)]="formData.selectedRFQNumber"
                        appearance="outline" bindLabel="value" bindValue="id" (change)="onRFQNumberChange($event)"
                        [appendTo]="'body'" style="padding-bottom: 0;">
                        <ng-template ng-option-tmp let-item="item">
                            <div>
                                {{ item.value }}
                            </div>
                        </ng-template>
                    </ng-select>
                    <p class="assistive-text paragraph-small-regular">Select the RFQ that you wish to tag attachment to
                    </p>
                </div>
                <div class="mt-4" *ngIf="formData.selectedRFQNumber">
                    <app-select-vendor-table (onSelectedChange)="onVendorNumberSelectedChange($event)"
                        [selectedVendorNumbers]="formData.selectedVendorNumbers"
                        [selectionMode]="SelectVendorTableSelectionMode.SINGLE"
                        [filterVendorNumbers]="filterVendorNumbers"
                        [isRemoveRowOnFilter]="true"></app-select-vendor-table>
                </div>
            </ng-container>
        </ng-container>

    </div>
    <div class="myPurchase-dialog-actions">
        <div mat-dialog-actions>
            <app-button class="padBtn cancelBtn" name="Cancel" mat-dialog-close (click)="onCancel()"></app-button>
            <app-button class="padBtn actionBtn" name="Confirm" type="flat-button" cdkFocusInitial
                (click)="onSubmit()"></app-button>
        </div>
    </div>
</div>